import { useSnapshot } from 'valtio';
import { subscribeKey } from 'valtio/utils';
import { ParamsStore } from '@context/params';
import { SortOrder } from '@graphql/reactQuery';
import { clearSortParams } from './helpers';
import type { ExploreTypeChoice } from './schema';
import { EXPLORE_TYPES, SEARCH_TAB_CHOICES, type TabChoice } from './schema';
import { searchPageStoreState } from './store';

export const MAX_SEARCH_HISTORY_SHOW = 5;
export const MAX_SEARCH_HISTORY_SAVE = 20;

export function setActiveTab({ activeTab }: { activeTab: TabChoice }) {
  searchPageStoreState.activeTab = activeTab;
}

export function setExploreType({ type }: { type: ExploreTypeChoice | null }) {
  ParamsStore.explore_type = type;
  searchPageStoreState.exploreType = type;
}

export function setDefaultSort({ type }: { type: ExploreTypeChoice | TabChoice | null }) {
  clearSortParams();

  if (type === EXPLORE_TYPES.PLAYLISTS) {
    ParamsStore.num_referral_purchases = SortOrder.Desc;
  } else {
    ParamsStore.total_volume = SortOrder.Desc;
  }
}

subscribeKey(searchPageStoreState, 'activeTab', () => {
  if (searchPageStoreState.activeTab == null) {
    ParamsStore.tab = SEARCH_TAB_CHOICES.ALL;
    searchPageStoreState.activeTab = SEARCH_TAB_CHOICES.ALL;
  }
});

export const useSearchPageStore = () => {
  const snapshot = useSnapshot(searchPageStoreState);

  return snapshot;
};
